import { render, staticRenderFns } from "./CustomTooltip.vue?vue&type=template&id=2d1363bc&scoped=true"
import script from "./CustomTooltip.vue?vue&type=script&lang=js"
export * from "./CustomTooltip.vue?vue&type=script&lang=js"
import style0 from "./CustomTooltip.vue?vue&type=style&index=0&id=2d1363bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1363bc",
  null
  
)

export default component.exports